(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boots-pdp-details"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('boots-pdp-tabs'))customElements.define('boots-pdp-tabs',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')];const select=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;this.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=tabs[(i+1)%tabs.length];if(e.key==='ArrowLeft')next=tabs[(i+tabs.length-1)%tabs.length];if(e.key==='Home')next=tabs[0];if(e.key==='End')next=tabs[tabs.length-1];if(next){e.preventDefault();select(next);next.focus();}});});}});
if(!customElements.get('boots-pdp-video'))customElements.define('boots-pdp-video',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const v=this.querySelector('video'),b=this.querySelector('button');const sync=()=>b.textContent=v.paused?b.dataset.play:b.dataset.pause;v.addEventListener('play',sync);v.addEventListener('pause',sync);if(matchMedia('(prefers-reduced-motion: reduce)').matches)v.pause();sync();b.addEventListener('click',()=>{if(v.paused)v.play().catch(sync);else v.pause();});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boots-pdp-more"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('boots-pdp-tabs'))customElements.define('boots-pdp-tabs',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')];const select=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;this.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=tabs[(i+1)%tabs.length];if(e.key==='ArrowLeft')next=tabs[(i+tabs.length-1)%tabs.length];if(e.key==='Home')next=tabs[0];if(e.key==='End')next=tabs[tabs.length-1];if(next){e.preventDefault();select(next);next.focus();}});});}});
if(!customElements.get('boots-pdp-video'))customElements.define('boots-pdp-video',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const v=this.querySelector('video'),b=this.querySelector('button');const sync=()=>b.textContent=v.paused?b.dataset.play:b.dataset.pause;v.addEventListener('play',sync);v.addEventListener('pause',sync);if(matchMedia('(prefers-reduced-motion: reduce)').matches)v.pause();sync();b.addEventListener('click',()=>{if(v.paused)v.play().catch(sync);else v.pause();});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-pdp-details"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pro-pdp-tabs')){customElements.define('pro-pdp-tabs',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;const tabs=[...this.querySelectorAll('[role=tab]')];const activate=tab=>{tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;this.querySelector('#'+item.getAttribute('aria-controls')).hidden=!selected;});};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=tabs[(index+1)%tabs.length];if(event.key==='ArrowLeft')next=tabs[(index+tabs.length-1)%tabs.length];if(event.key==='Home')next=tabs[0];if(event.key==='End')next=tabs[tabs.length-1];if(next){event.preventDefault();activate(next);next.focus();}});});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relief-pdp-details"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('relief-pdp-tabs'))customElements.define('relief-pdp-tabs',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')];const select=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;this.querySelector('#'+t.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=tabs[(i+1)%tabs.length];if(e.key==='ArrowLeft')next=tabs[(i+tabs.length-1)%tabs.length];if(e.key==='Home')next=tabs[0];if(e.key==='End')next=tabs[tabs.length-1];if(next){e.preventDefault();select(next);next.focus();}});});}});

  } catch(e) { console.error(e); }
})();
})();
